import React, { useContext, useEffect, useState } from 'react'
import { RegistrationFormContext } from './types'
import { InputElement } from '../../../../HtmlComponents/InputElement'
import { SexType, cabinetInterface } from '../../../cabinets/types'
import { SelectElement } from '../../../../HtmlComponents/SelectElement'
import ReactSelect from 'react-select'
import { InputImage } from '../../../../HtmlComponents/InputImage'
import { useSelector } from 'react-redux'
import { State } from '../../../../redux/store'
import { hostName } from '../../../../requestMethods'
import { TextAreaElement } from '../../../../HtmlComponents/TextAreaElement'

const Section1 = () => {
  const {
    fullName, setFullName,
    yearOfBirth, setYearOfBirth,
    placeOfBirth, setPlaceOfBirth,
    sex, setSex,
    telephone, setTelephone,
    whatsapp, setWhatsapp,
    email, setEmail,
    origin, setOrigin,
    current, setCurrent,
    medecinType, setMedecinType,
    avatar, setAvatar,
    password, setPassword,
    speciality, setSpeciality,
    cabinet, setCabinet,
    practiceLocations, setPracticeLocations,
  } = useContext(RegistrationFormContext)

  const { cabinets } = useSelector((state: State) => state.cabinets)

  const [listCabinet, setListCabinet] = useState<any[]>([])

  useEffect(() => {
    setListCabinet(cabinets.map((cliniq: cabinetInterface) => ({ value: cliniq._id, label: cliniq.name })))
  }, [cabinets])

  const { medecinTypes } = useSelector((state: State) => state.medecinType)

  const [selectedMedecineType, setSelectedMedecineType] = useState<any[]>([])

  useEffect(() => {
    setSelectedMedecineType(medecinTypes.map((docType: any) => ({ _id: docType._id, name: docType.title })))
  }, [medecinTypes])


  return (
    <>
      <InputElement labelClass='text-main' name="1) Nom Complet" placeholder='Nom Complet' value={fullName} setValue={setFullName} />
      <SelectElement labelClass='text-main' name="2) Sexe" options={SexType} defaultOption={<option>Choisir un sexe</option>} value={sex} setValue={setSex} />
      <InputElement labelClass='text-main' type="number" name="3) Annee de naissance" placeholder='Annee de naissance' value={yearOfBirth} setValue={setYearOfBirth} />
      <InputElement labelClass='text-main' name="4) Lieu de naissance" placeholder='Lieu de naissance' value={placeOfBirth} setValue={setPlaceOfBirth} />
      <InputElement labelClass='text-main' type="password" name="Mot de passe" placeholder='Mot de passe' value={password} setValue={setPassword} />
      <div>
        <p className='font-bold text-main'>{"5) "}Adresse Personnelle</p>    
        <InputElement name="Telephone" placeholder='Telephone' value={telephone} setValue={setTelephone} />
        <InputElement name="Whatsapp" placeholder='Whatsapp' value={whatsapp} setValue={setWhatsapp} />
        <InputElement type="text" name="Email" placeholder='Email' value={email} setValue={setEmail} />  
      </div>
      <TextAreaElement labelClass="text-main" labelName={`6) Adresse complète de vos lieux actuels d exercice ou des lieux où vous projetez d'exercer la médecine, précisez les téléphones`} value={practiceLocations} setValue={setPracticeLocations}/>
      <div>
        <p className='font-bold text-main'>{"7) "}Nationalite</p>    
        <InputElement name="Actuelle" placeholder='Actuelle' value={current} setValue={setCurrent} />
        <InputElement name="Originaire" placeholder='Originaire' value={origin} setValue={setOrigin} />
        <SelectElement name="Medecin" options={selectedMedecineType} defaultOption={<option>Choisir type</option>} value={medecinType} setValue={setMedecinType} />
      </div>
      <div className='mb-2 flex flex-col justify-between'>
        <span className=''></span>
        <InputElement name="Specialité" placeholder='Specialité' value={speciality} setValue={setSpeciality} />
        <div>
          <label className='font-bold text-gray-700' htmlFor="cabinet">Choisir un clinique</label>
          <ReactSelect id="cabinet" onChange={(e) => setCabinet(e)} value={cabinet} placeholder="Cabinets" options={listCabinet}/>
        </div>
      </div>
      <div>
      <InputImage name="Profile" setValue={setAvatar} />
      {/* image comes from db */}
      {(avatar && (typeof avatar === 'string')) && <div className='flex justify-center items-center'>
        <img className='rounded-full shadow-lg' style={{ width: "100px", height: "100px" }} src={hostName + "imgs/doctors/" + avatar} alt="avatar" /> 
      </div>}
      {/* image choosen from here */}
      {(avatar && (typeof avatar !== 'string')) && <div className='flex justify-center items-center'>
        <img className='rounded-full shadow-lg' style={{ width: "100px", height: "100px" }} src={URL.createObjectURL(avatar)} alt="avatar" /> 
      </div>}
      </div>
    </>
  )
}

export default Section1